import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/authentication/auth.guard';


const routes: Routes = [
  {
    path: 'envios',
    canLoad: [AuthGuard],
    loadChildren: () => import('./modules/inventory/shipments/shipments.module').then(m => m.ShipmentsModule)
  },
  {
    path: 'bodega',
    canLoad: [AuthGuard],
    loadChildren: () => import('./modules/inventory/warehouse/warehouse.module').then(m => m.WarehouseModule)
  },
  {
    path: '**', pathMatch: 'full', redirectTo: 'envios'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
